// extracted by mini-css-extract-plugin
export var content = "_d4-3";
export var list = "_d4-4";
export var settingsContent = "_d4-7";
export var settingsPanel = "_d4-8";
export var state = "_d4-6";
export var triggerBadge = "_d4-2";
export var triggerButton = "_d4-1";
export var triggerShell = "_d4-0";
export var unreadDot = "_d4-5";